import React, { useEffect, useState } from "react";
// Components
import { TableBody, TableHead } from "./components";
// Hooks
import useActions from "hooks/useActions";
// Store Utils
import { speciesSortingAction } from "store/filters";
import { useDispatch } from "react-redux";
// Utils
import exportDataToCsv from "utils/exportDataToCsv";
import getAllRowsData from "utils/getAllRowsData";
// Exteranl Tools
import { snakeCase } from "change-case";
// Styling
import "./Communities.scss";
// types
import { TableProps } from "./types";
import apiLibrary from "services/api";
import { Toasts } from "view/components/Toasts";
import { filterKeys } from "Components/Users/Table";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { filtersInitialState } from "store/filters/initialState";
import { openReUseSpeciesListModalAction } from "store/modals";
import { useParams } from "react-router-dom";
import usePermissions from "hooks/usePermissions";
import { getParentEntity } from "utils/getParentEntitywithParams";

export const KEYS_TO_BE_REMOVED = ["id"];
const generatingDirectoryActions = (
  columns: any,
  rowsData: any,
) => {
  const dispatch = useDispatch();
  const { communities } = usePermissions();
  const { communityId } = useParams();
  const fileDownload = async () => {
    if (rowsData.length === 0) {
      Toasts.error("Please select at least one specie from the table");
      return;
    }
    try {
      const res = await apiLibrary.file.fileDownload(
        "species",
        columns,
        rowsData.map((item: any) => {
          return item.commonName.id;
        })
      );

      // Convert the response to a Blob
      const blob = new Blob([res], { type: "application/octet-stream" });

      // Create a link element
      const link = document.createElement("a");

      // Set the href attribute to a URL created from the Blob
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute to specify the file name
      link.download = `species_${new Date().toISOString()}.csv`;

      // Append the link to the body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the DOM
      document.body.removeChild(link);

      Toasts.success("Download complete");
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
    }
  };

  return [
    {
      label: "Reuse Species List",
      onClick: () => dispatch(openReUseSpeciesListModalAction()),
      divider: false,
      isVisible:
        communities.canCreateReuseListCommunities && communityId ? true : false,
    },
    {
      label: "Export Details",
      onClick: () => fileDownload(),
      divider: false,
      isVisible: true,
    },
  ];
};

export const Table: React.FC<TableProps> = ({
  table,
  columnOrder,
  columns,
  columnVisibility,
  flexRender,
  setSorting,
  sorting,
}) => {
  const dispatch = useDispatch();
  const { specieActions } = useActions();
  const { speciesFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );
  const { programId, communityId, organizationId } = useParams();

  const DirectoryActions = () => {
    const filteredKeys = filterKeys(columnVisibility, columnOrder);
    return generatingDirectoryActions(
      filteredKeys,
      getAllRowsData(table, columnOrder, columnVisibility, columns),
    );
  };

  const getSpeciesActions = (data: any) => {
    const modalData = {
      status: speciesFilter.status,
      id: data.id,
      path: "directory",
      createdById: data.createdById
    };

    return specieActions(modalData);
  };

  const toggleSorting = (columnId: string) => {
    setSorting((currentSorting: any) => {
      const existingSort = currentSorting.find(
        (sort: any) => sort.columnId === columnId
      );
      const columnsId = snakeCase(columnId);
      if (!existingSort) {
        dispatch(speciesSortingAction(columnsId, "asc"));
        return [{ columnId, type: "asc" }];
      } else if (existingSort.type === "asc") {
        dispatch(speciesSortingAction(columnsId, "desc"));
        return [{ columnId, type: "desc" }];
      } else {
        dispatch(speciesSortingAction("", ""));

        return [];
      }
    });
  };
  const [hoveredHeader, setHoveredHeader] = useState<any>([]);
  const handleClickOnTableColumnHeading = (header: any, id: any) => {
    if (id === 1) {
      setHoveredHeader("");
      header.column.getCanSort() && toggleSorting(header.column.id);
      // setHoveredHeader(null);
    } else {
      setHoveredHeader(header.id);
    }
    // if(header.column)
    // header.column.getCanSort() && toggleSorting(header.column.id);
    // setHoveredHeader(null);
  };
  return (
    <div className="w-full overflow-hidden max-h-[80vh] overflow-x-auto overflow-y-auto">
      <table className="w-full">
        <TableHead
          table={table}
          sorting={sorting}
          flexRender={flexRender}
          DirectoryActions={DirectoryActions()}
          handleClickOnColumnHead={handleClickOnTableColumnHeading}
          setHoveredHeader={setHoveredHeader}
          hoveredHeader={hoveredHeader}
        />
        <TableBody
          flexRender={flexRender}
          table={table}
          columnVisibility={columnVisibility}
          getSpeciesActions={getSpeciesActions}
        />
      </table>
    </div>
  );
};
